import './nearbyMap.js'

(function () {
    //console.log("NBP")
    const nearbyPlacesEls = document.querySelectorAll(".nearby");
    nearbyPlacesEls.forEach(nearbyPlaceEl => {
        console.log("got one")
        const el = document.createElement('nearby-map');
        nearbyPlaceEl.appendChild(el);
    })
})()